import { defineComponent as d, ref as a, computed as i, openBlock as s, createElementBlock as u, normalizeClass as m, renderSlot as c } from "vue";
import { _ as h } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const p = [
  // Layout
  "layout-inline-row",
  // Theme
  "theme-foreground-outline",
  "dark:theme-foreground-outline-dark"
], f = d({
  name: "OrInputBoxAddon",
  props: {
    invalid: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup() {
    const e = a(), n = i(() => [
      "or-input-box-addon-v3",
      ...p
    ]);
    return {
      root: e,
      rootStyles: n
    };
  }
}), y = ["invalid", "readonly", "disabled"];
function k(e, n, o, S, x, _) {
  return s(), u("div", {
    ref: "root",
    class: m(e.rootStyles),
    invalid: e.invalid,
    readonly: e.readonly,
    disabled: e.disabled
  }, [
    c(e.$slots, "default")
  ], 10, y);
}
const b = /* @__PURE__ */ h(f, [["render", k]]);
var t = /* @__PURE__ */ ((e) => (e.Row = "row", e.Column = "column", e))(t || {}), r = /* @__PURE__ */ ((e) => (e.Styled = "styled", e.Unstyled = "unstyled", e.Embedded = "embedded", e))(r || {}), l = /* @__PURE__ */ ((e) => (e.M = "m", e.S = "s", e))(l || {});
const v = [
  // Overflow
  "overflow-hidden",
  // Box
  "w-full",
  // Shape
  "rounded-md",
  // Theme (children)
  "children:outline-none"
], g = {
  [t.Row]: [
    // Layout
    "layout-row"
  ],
  [t.Column]: [
    // Layout
    "layout-column"
  ]
}, w = {
  [r.Styled]: [
    // Theme
    "theme-preset-3-primary",
    "dark:theme-preset-3-primary-dark",
    "theme-foreground-default",
    "dark:theme-foreground-default-dark",
    "theme-border-outline border-1",
    "dark:theme-border-outline-dark",
    "theme-outline-transparent outline-2",
    "dark:theme-outline-transparent",
    // Theme (focus)
    "focus-within:theme-background-primary-translucent-1",
    "dark:focus-within:theme-background-primary-translucent-1-dark",
    "focus-within:theme-border-primary focus-within:border-1",
    "dark:focus-within:theme-border-primary-dark",
    "focus-within:theme-outline-primary focus-within:outline-2",
    "dark:focus-within:theme-outline-primary-dark",
    // Theme (invalid)
    "invalid:theme-preset-3-error",
    "dark:invalid:theme-preset-3-error-dark",
    "invalid:theme-background-error-translucent-1",
    "dark:invalid:theme-background-error-translucent-1-dark",
    "invalid:theme-foreground-default",
    "dark:invalid:theme-foreground-default-dark",
    "invalid:theme-border-error invalid:border-1",
    "dark:invalid:theme-border-error-dark",
    "invalid:theme-outline-transparent invalid:outline-2",
    "dark:invalid:theme-outline-transparent",
    // Theme (invalid + focus)
    "invalid:focus-within:theme-background-error-translucent-1",
    "dark:invalid:focus-within:theme-background-error-translucent-1-dark",
    "invalid:focus-within:theme-border-error invalid:focus-within:border-1",
    "dark:invalid:focus-within:theme-border-error-dark",
    "invalid:focus-within:theme-outline-error invalid:focus-within:outline-2",
    "dark:invalid:focus-within:theme-outline-error-dark",
    // Theme (read-only)
    "read-only:theme-background-primary-translucent-1",
    "dark:read-only:theme-background-primary-translucent-1-dark",
    "read-only:!border-transparent",
    "dark:read-only:!border-transparent",
    // Theme (invalid + read-only)
    "invalid:read-only:bg-error-opacity-0-08",
    "dark:invalid:read-only:bg-error-opacity-0-08-dark",
    "invalid:read-only:!border-transparent",
    "dark:invalid:read-only:!border-transparent"
  ],
  [r.Unstyled]: [
    // Theme (disabled)
    "disabled:theme-foreground-disabled",
    "dark:disabled:theme-foreground-disabled-dark"
  ],
  [r.Embedded]: [
    // Spacing (children)
    "first:children:!ms-0",
    "last:children:!me-0"
  ]
}, B = {
  "m-row": [
    // Box (children)
    "children:min-h-[46px] md:children:min-h-[34px]",
    // Spacing
    "gap-sm+ md:gap-sm",
    // Spacing (children)
    "first:children:ms-md md:first:children:ms-sm+",
    "last:children:me-md md:last:children:me-sm+",
    // Typography
    "typography-body-2-regular"
  ],
  "m-column": [
    // Typography
    "typography-body-2-regular"
  ],
  "s-row": [
    // Box (children)
    "children:min-h-[30px]",
    // Spacing
    "gap-[6px]",
    // Spacing (children)
    "first:children:ms-md md:first:children:ms-sm+",
    "last:children:me-md md:last:children:me-sm+",
    // Typography
    "typography-caption-regular"
  ],
  "s-column": [
    // Typography
    "typography-caption-regular"
  ]
}, C = d({
  name: "OrInputBox",
  components: {
    OrInputBoxAddon: b
  },
  props: {
    direction: {
      type: String,
      default: () => t.Row
    },
    variant: {
      type: String,
      default: () => r.Styled
    },
    size: {
      type: String,
      default: () => l.M
    },
    invalid: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  emits: [
    "focus"
  ],
  setup(e) {
    const n = a(), o = i(() => [
      "or-input-box-v3",
      ...v,
      ...g[e.direction],
      ...w[e.variant],
      ...B[`${e.size}-${e.direction}`]
    ]);
    return {
      root: n,
      rootStyles: o
    };
  }
});
export {
  t as I,
  C as _,
  r as a,
  l as b
};
//# sourceMappingURL=OrInputBox.vue_vue_type_script_lang-q2L7rmth.mjs.map
